export default {
  BASE_URL: '/',
  api: [
    {
      name: 'getCategoryBy14',
      method: 'GET',
      desc: '主营分类',
      path: 'category/module/category?parentId=14&mall=true&head=false'
    },
    {
      name: 'getCollectInfo',
      method: 'GET',
      desc: '获取需求信息',
      path: 'om/cenPurchase/getInfo'
    },
    {
      name: 'updateCollectStatus',
      method: 'POST',
      desc: '更新需求信息',
      path: 'om/cenPurchase/auditInfo'
    },
    {
      name: 'getCollectInfoStatus',
      method: 'GET',
      desc: '获取需求状态',
      path: 'om/cenPurchase/getInfoStatus'
    },
    {
      name: 'getCollectUserName',
      method: 'GET',
      desc: '获取需求用户名',
      path: 'om/cenPurchase/getUserName'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/admin/admin.js